var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 256C14.9333 256 10.6667 253.867 6.4 249.6C-2.13333 241.067 -2.13333 228.267 6.4 219.733L219.733 6.4C228.267 -2.13333 241.067 -2.13333 249.6 6.4C258.133 14.9333 258.133 27.7333 249.6 36.2667L36.2667 249.6C32 253.867 27.7333 256 21.3333 256Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.667 234.667C221.867 234.667 213.333 226.133 213.333 213.333V42.6667H42.6666C29.8666 42.6667 21.3333 34.1333 21.3333 21.3333C21.3333 8.53333 29.8666 0 42.6666 0H234.667C247.467 0 256 8.53333 256 21.3333V213.333C256 226.133 247.467 234.667 234.667 234.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFooter);
export default __webpack_public_path__ + "static/media/arrow-footer.6ed4b724f42922a53c209dd06ae0b180.svg";
export { ForwardRef as ReactComponent };